import * as t from './types'

export const refreshBadwordscore = ({
  language,
  badwordLevel,
  sexualLevel,
  str,
}) => ({
  type: t.REFRESH_BADWORDSCORE,
  payload: { language, badwordLevel, sexualLevel, str },
  meta: {
    offline: {
      effect: {
        path: 'admin/special/badwordscore',
        method: 'POST',
      },
      commit: {
        type: t.REFRESH_BADWORDSCORE_SUCCESS,
      },
      rollback: { type: t.REFRESH_BADWORDSCORE_ERROR },
    },
  },
})

export const rerollExperiments = (payload) => ({
  type: t.REROLL_EXPERIMENTS,
  payload,
  meta: {
    offline: {
      effect: { path: 'admin/experiments/rerollcountry', method: 'POST' },
      commit: { type: t.REROLL_EXPERIMENTS_SUCCESS },
      rollback: { type: t.REROLL_EXPERIMENTS_ERROR },
    },
  },
})
